/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Danish (Denmark)
export default {
  'share-modal.accordion-button-label':
    '{entity, select, project {Hvem skal have ugentlige projektopdateringer?} goal {Hvem får ugentlige målopdateringer?} other {Hvem får ugentlige opdateringer?}}',
  'share-modal.add-as-follower-checkbox-label': 'Tilføj som følger',
  'share-modal.add-as-follower-checkbox-tooltip':
    '{entity, select, project {Følgere får en ugentlig opdatering om projekter i deres overblik} goal {Følgere får en ugentlig opdatering om mål i deres overblik} other {Følgere får en ugentlig opdatering i deres overblik}}',
  'share-modal.all-tab-label': 'Alle',
  'share-modal.contributors-tab-label': 'Bidragsydere',
  'share-modal.followers-tab-label': 'Følgere',
  'share-modal.followers-title': 'Følgere',
  'share-modal.footer.access-level-disclaimer':
    '{entity, select, project {Alle med adgang til arbejdsområdet kan se dette projekt.} goal {Alle med adgang til arbejdsområdet kan se dette mål.} other {Alle med adgang til arbejdsområdet kan se dette.}}',
  'share-modal.footer.access-level-private-disclaimer':
    '{entity, select, project {Privat projekt} goal {Privat mål} other {}}',
  'share-modal.footer.copy-link-button': 'Kopiér link',
  'share-modal.footer.copy-link-button.copied-tooltip': 'Kopieret!',
  'share-modal.footer.copy-link-button.tooltip':
    '{entity, select, project {Kopiér link til projekt} goal {Kopiér link til mål} other {Kopiér link til }}',
  'share-modal.modal.user-picker.add-more-placeholder': 'Tilføj flere personer',
  'share-modal.share-button': 'Del',
  'share-modal.share-title': 'Del',
  'share-modal.user-item.can-edit-label': 'Kan redigere',
  'share-modal.user-picker.placeholder': 'Søg efter og invitér personer',
  'shareModal.followers-empty-state.default-title': 'Mangler der centrale interessenter?',
  'shareModal.followers-empty-state.goal-cta':
    'Sørg for, at de bliver opdateret om det seneste mål i deres månedlige oversigt ved at tilføje dem som følger eller ved at tilknytte en Slack- eller MS Teams-kanal',
  'shareModal.followers-empty-state.project-cta':
    'Tilføj centrale teams og interessenter som følgere, så de altid holdes opdateret. Tilknyt en kanal for at dele opdateringer direkte i chats.',
  'shareModal.followers-empty-state.project-title': 'Nå ud til flere ved at tilføje følgere',
};
